export function Stepper({ value, onChange }: { value: number; onChange: (v: number) => void }) {
  return (
    <div className="flex items-center justify-between gap-1">
      <button
        type="button"
        className="w-7 h-7 shrink-0 rounded-lg bg-s2 border border-line cursor-pointer inline-flex items-center justify-center"
        onClick={() => onChange(Math.max(0, value - 1))}
      >−</button>
      <input
        type="number"
        min={0}
        value={value}
        onChange={(e) => onChange(Math.max(0, parseInt(e.target.value, 10) || 0))}
        className="no-spinner serif flex-1 min-w-0 text-center text-[20px] bg-transparent border-none outline-none"
      />
      <button
        type="button"
        className="w-7 h-7 shrink-0 rounded-lg bg-s2 border border-line cursor-pointer inline-flex items-center justify-center"
        onClick={() => onChange(value + 1)}
      >+</button>
    </div>
  )
}
